import QuoteForm from "./modules/QuoteForm";
import base64decode from "./utils/base64decode";

const domReady = () => {
    const quoteFormNode = document.querySelector('.quote-form');

    if (quoteFormNode) {
        QuoteForm(quoteFormNode);
    }

    document.querySelectorAll(".js-decode-base64").forEach(el => {
        base64decode(el);
    });

};

document.addEventListener("DOMContentLoaded", domReady);